import * as React from 'react';

function SvgShowPasswordOff(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 3.333C4.054 3.333.214 9.474.145 9.586a.667.667 0 00-.037.777l.003.004c.011.024 3.235 6.3 9.889 6.3 6.626 0 9.845-6.215 9.884-6.29a.667.667 0 00-.027-.79l-.002-.001c-.069-.112-3.91-6.253-9.855-6.253zm0 2a4.667 4.667 0 110 9.334 4.667 4.667 0 010-9.334z"
        fill="#414B56"
      />
      <path stroke="#414B56" strokeLinecap="round" d="M1.707 2L17 17.293" />
    </svg>
  );
}

export default SvgShowPasswordOff;
